import request from '@/CommonDP/utils/request';
// 组织架构
export default {
  // 本部门下的人员列表
  orgUserList(params) {
    return request.post(`/dept/member/list`, params);
  },
  updateMemberDept(params) {
    return request.post(`/dept/updateMemberDept`, params);
  },
  // 查询全部的部门人员列表-新写的
  orgUserQueryAllMemberList(params) {
    return request.post(`/dept/queryAllMemberList`, params);
  },
  // 人员列表弹框
  personList(params) {
    return request.post(`/enterprise/personnel/getPersonnelList`, params);
  },
  // 部门下的人员添加
  orgUser(params) {
    return request.post(`/dept/member/add`, params);
  },
  // 左侧树
  getOrgTree(enterpriseId) {
    return request.get(`/org/getOrgTree?enterpriseId=${enterpriseId}`);
  },

  // 部门下的人员移除
  delOrgUser(params) {
    return request.post(`/dept/member/delete`, params);
  },

  // 添加目录树
  newAddTree(params) {
    return request.post(`/org/addDept`, params);
  },
  // 删除组织树
  deleteOrgTree(deptId) {
    return request.get(`/org/deleteDept?deptId=` + deptId);
  },
  // 组织详情
  orgInfo(deptId) {
    return request.get(`/org/getDeptDetails?deptId=${deptId}`);
  },
  // 修改组织列表
  updateOrgInfo(params) {
    return request.post(`/org/updateDept`, params);
  },
  // 移动组织
  moveOrg(deptId, moveType) {
    return request.get(`/org/move?deptId=${deptId}&moveType=${moveType}`);
  },
  // 设置主管
  addLeader(params) {
    return request.post(`/dept/leader`, params).then((res) => res);
  },
  // 添加分管领导
  addDivisionLeader(deptId, params) {
    return request.post(`/org/${deptId}/chargeLeaders`, params).then((res) => res);
  },
  // 删除分管领导
  delDivisionLeader(deptId, userId) {
    return request.post(`/org/chargeLeader/delete?deptId=${deptId}&userId=${userId}`).then((res) => res);
  }
};
